import config from './api.config'

export const formatRequest = request => {
  if (!request) {
    return {}
  }
  return JSON.parse(JSON.stringify(request))
}

export const getHeaders = () => {
  let headers = formatRequest(config.axiosConfig().headers)
  return headers
}
export const getHeaderLogin = () => {
  let headers = formatRequest(config.axiosConfig().headerLogin)
  return headers
}
export const getFileHeaders = () => {
  let headers = formatRequest(config.axiosConfig().FileHeaders)
  return headers
}
export const getLcpHeaders = () => {
  let headers = formatRequest(config.axiosConfig().lcpHeaders)
  return headers
}
export function  getOrganizationHeaders(OrganizationID) {
  let headers = formatRequest(config.axiosOrganizationConfig(OrganizationID).headers)
  return headers
}


// WEBPACK FOOTER //
// ./src/api/api-helpers.js